import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const currentUser = JSON.parse(localStorage.getItem('currentUser') ?? '{}');

        if (currentUser && currentUser.token) {
            const headers: Record<string, string> = {
                Authorization: `Bearer ${currentUser.token}`,
            };

            // Superadmin: attach selected company context to every request
            if (currentUser.role === 'superadmin') {
                const companyId = localStorage.getItem('selectedCompanyId');
                if (companyId) {
                    headers['X-Company-ID'] = companyId;
                }
            }

            request = request.clone({ setHeaders: headers });
        }

        return next.handle(request);
    }
}
